/**
 * API ENDPOINT
 */
export const apiEndpointBaseUrl = 'https://shop.gmts.eplatform.vn'

/**
 * SYSTEM DEFAULT
 */
export const defaultDatetimeFormat = 'HH:mm DD/MM/YYYY'
